// extracted by mini-css-extract-plugin
export default {"wrapper":"Cosy3jLDYKAPtdvOwC4w","collapse":"fUMr8h5dLEMkJFRtyKMY","content":"P9PYffFymgrGE2LfIEad"};